var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-row",
    { staticClass: "align-items-center", attrs: { "no-gutters": "" } },
    [
      _c(
        "b-col",
        { attrs: { col: "" } },
        [
          _c(
            "b-row",
            { staticClass: "align-items-center", attrs: { "no-gutters": "" } },
            [_vm._t("left")],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-col",
        {
          staticClass: "mt-xl-0 mt-2",
          class: { "d-none": !_vm.$slots.right },
          attrs: { cols: "12", md: "auto", lg: "12", xl: "auto" },
        },
        [
          _c(
            "b-row",
            {
              staticClass: "align-items-center justify-content-lg-end",
              attrs: { "no-gutters": "" },
            },
            [_vm._t("right")],
            2
          ),
        ],
        1
      ),
      _vm._v(" "),
      _vm.showPin
        ? _c(
            "span",
            {
              staticClass: "pin-item clickable",
              class: _vm.pinned ? "pinned" : "",
              on: { click: _vm.handlePin },
            },
            [
              _c("i", {
                staticClass: "fa fa-thumb-tack",
                attrs: { "aria-hidden": "true" },
              }),
            ]
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }